import { parseFunction, replaceDynamicParameter } from './functionParser';
import { DYNAMIC_PARAMETER_TYPE } from './functionParser/constant';
import { getRenderComponentById, getRenderDataSource } from '../store/common/action';
import { recursionCustomParams } from './common';

/**
 * 事件类型枚举（包含所有需要分组的事件）
 */
export const EVENT_ENUM = {
  event: 'event',
  click: 'click',
  clickDone: 'clickDone',
  uploadSuccess: 'uploadSuccess',// 上传成功事件
  tableRowEvent: 'tableRowEvent',// 表格多选单选行事件
  addForm: 'addForm', // 添加表单事件
  lineDblClick: 'lineDblClick', // 行双击事件
  dblclick: 'dblclick',
  mouseover: 'mouseover',
  mouseout: 'mouseout',
  mousedown: 'mousedown',
  mouseup: 'mouseup',
  mousemove: 'mousemove',
  mouseenter: 'mouseenter',
  mouseleave: 'mouseleave',
  keydown: 'keydown',
  keyup: 'keyup',
  blur: 'blur',
  focus: 'focus',
  change: 'change',
  loadeddata: 'loadeddata',
  loadedmetadata: 'loadedmetadata',
  loadstart: 'loadstart',
  play: 'play',
  pause: 'pause',
  playing: 'playing',
  progress: 'progress',
  waiting: 'waiting',
  ended: 'ended',
  add: 'add', // 添加事件
  drop: 'drop',
  resize: 'resize',
  del: 'del', // 删除事件
  edit: 'edit', // 编辑事件
  down: 'down',
  touchstart: 'touchstart',
  touchend: 'touchend',
  touchmove: 'touchmove',
  longpress: 'longpress',
  touchendSuccess: 'touchendSuccess'
};

/**
 * 事件函数
 * @param data  节点
 * @param key   事件、触发器
 * @param instanceId
 */
export const eventFun = async (data, key, instanceId) => {
  console.log('eventFun', _cloneDeep(data), key);
  const componentItem = getRenderComponentById(instanceId, data.prop);
  const prop = _get(data, 'prop');
  if (!prop) {
    return;
  }
  const { event } = componentItem;
  if (!event) {
    return;
  }
  if (event[key]?.triggerSetting) {
    setClickObjectRowValueToAttrs(data, instanceId, componentItem)
    //解析可视化逻辑
    if (_size(_get(event[key], 'triggerSetting.functionBody')) > 0) {
      let triggerSetting = _cloneDeep(event[key].triggerSetting);
      // 递归获取参数
      const customParamMap = recursionCustomParams(triggerSetting.functionBody,{})
      const customParamsList = Object.values(customParamMap)
      // 处理当前触发的对象和prop
      replaceDynamicParameter(customParamsList, DYNAMIC_PARAMETER_TYPE.CURRENT_PROP, prop);
      replaceDynamicParameter(customParamsList, DYNAMIC_PARAMETER_TYPE.CURRENT_COMPONENT, componentItem);
      await parseFunction(triggerSetting.functionBody, customParamsList, [], instanceId);
    }
  }
};

// 设置点击的行数据到触发对象的rowValue属性中
function setClickObjectRowValueToAttrs(data, instanceId, componentItem){
  const dataResult = getRenderDataSource(instanceId, componentItem.dataSource)
  const rowData = _get(dataResult, ['items', data.dataIndex]);
  const { attrs } = componentItem;
  if (rowData){
    // 执行删除
    deleteImageTargetField(rowData);
    // 安全解构 data 属性，无值时赋值空对象，避免解构报错
    const { data = {}, ...restRowData } = rowData;
    // 合并数据并覆盖原对象（替代 Object.assign + delete 冗余操作）
    const mergedRowData = { ...restRowData, ...data };
    // 赋值到目标属性（使用数组路径更规范，可读性更强）
    _set(attrs, ['rowValue', 'value'], mergedRowData);
  }
}

// 过滤条件不会使用图片字典--删除图片字段（原因：图片中含base64编码字段，过大）;
function deleteImageTargetField(obj) {
  if (typeof obj !== 'object' || obj === null) return;
  // 如果当前对象包含这个字段，直接删除整个字段
  if (obj.hasOwnProperty('p_car_model_image_url')) {
    delete obj.p_car_model_image_url;
  }
  // 递归遍历所有子对象/数组
  Object.values(obj).forEach(val => deleteImageTargetField(val));
}

/**
 * 表格的行按钮事件触发
 * @param data 表格组件的AST
 * @param key 表格组件触发事件的名称,例如：click
 * @param eventKey 表格组件触发按钮的prop
 * @param instanceId 页面实例的ID
 * @returns
 */
export const tableEventFun = async (data, key,eventKey, instanceId) => {
  console.log('tableEventFun', data, key);
  const componentItem = getRenderComponentById(instanceId, data.prop);
  const prop = _get(data, 'prop');
  if (!prop) {
    return;
  }
  console.log(componentItem);
  const customBtn = _get(componentItem,'customBtn')
  if (!customBtn) {
    return;
  }
  if (customBtn[eventKey][key]?.triggerSetting) {
    //解析可视化逻辑
    if (_size(_get(customBtn[eventKey][key], 'triggerSetting.functionBody')) > 0) {
      let triggerSetting = customBtn[eventKey][key].triggerSetting;
      const customParamMap = recursionCustomParams(triggerSetting.functionBody,{})
      const customParamsList = Object.values(customParamMap)
      replaceDynamicParameter(customParamsList, DYNAMIC_PARAMETER_TYPE.CURRENT_PROP, prop);
      // table按钮事件这种的函数：“组件触发当前对象" 替换成 table 组件本身
      await modifyCurrentComponentProp(triggerSetting.functionBody, prop)
      await parseFunction(triggerSetting.functionBody, customParamsList, [], instanceId);
    }
  }
};

/**
 * table按钮事件这种的函数：“组件触发当前对象" 替换成 table 组件本身
 * @param data
 * @param table_prop
 */
export const modifyCurrentComponentProp = async (data, table_prop) => {
  // 递归处理函数
  function processItem(item) {
    // 如果是数组，遍历每个元素
    if (Array.isArray(item)) {
      item.forEach(processItem);
    }
    // 如果是对象，检查并处理
    else if (item && typeof item === 'object') {
      // 检查当前对象是否paramType为"dynamic"
      if (item.paramType === 'dynamic' && item.key ==="currentComponent" && 'prop' in item) {
        item.paramType = "fixed";
        item.value = table_prop;
        item.valueType = "String";
      }
      // 遍历对象的所有属性，继续递归处理
      Object.values(item).forEach(processItem);
    }
  }

  // 只从body节点开始处理
  if (Array.isArray(data)) {
    data.forEach(item => {
      if (item.body) {
        processItem(item.body);
      }
    });
  }
  return data;
}
